import { render, staticRenderFns } from "./FriendApply.vue?vue&type=template&id=411d3b44&scoped=true"
import script from "./FriendApply.vue?vue&type=script&lang=js"
export * from "./FriendApply.vue?vue&type=script&lang=js"
import style0 from "./FriendApply.vue?vue&type=style&index=0&id=411d3b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d3b44",
  null
  
)

export default component.exports